import { Box } from '@mui/material';

import { IEMDRContext, IWhiteboardContext } from 'context';
import { useEMDR, useRoomHost, useWhiteboard } from 'hooks';
import { EMDRProviderContainer } from '../EMDRProviderContainer/EMDRProviderContainer';
import { WhiteboardContainer } from '../WhiteboardContainer';
import { MainParticipant } from '../MainParticipant';
import { ParticipantList } from '../ParticipantList';
import { ApiUser } from 'types';
import { useAppSelector } from 'store';
import { selectUser } from 'store/user';

import styles from './SpeakerView.module.scss';

export function SpeakerView(): JSX.Element {
  const { state: emdrState }: IEMDRContext = useEMDR();
  const { state: whiteboardState, isFullScreen: isWhiteboardFullScreen }: IWhiteboardContext = useWhiteboard();
  const { isHost } = useRoomHost();
  const user: ApiUser | null = useAppSelector(selectUser);
  const showMainParticipant = whiteboardState === 'off' && (emdrState === 'off' || !isHost);
  const showEmdrProviderContainer = isHost && emdrState !== 'off' && user;

  return (
    <Box className={styles.container}>
      <ParticipantList />
      {showMainParticipant && <MainParticipant />}
      {showEmdrProviderContainer && <EMDRProviderContainer />}
      {whiteboardState !== 'off' && !isWhiteboardFullScreen && <WhiteboardContainer />}
    </Box>
  );
}
